import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=5dd631dc&"
import script from "./Widget.vue?vue&type=script&lang=js&"
export * from "./Widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dd631dc')) {
      api.createRecord('5dd631dc', component.options)
    } else {
      api.reload('5dd631dc', component.options)
    }
    module.hot.accept("./Widget.vue?vue&type=template&id=5dd631dc&", function () {
      api.rerender('5dd631dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Statistics/TouchpointInfo/Widget.vue"
export default component.exports